import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const locationFromJSON = (json: Partial<ILocationData>): LocationRecord => {
  const recordData: ILocationRecord = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  if (json.org_location_link) {
    recordData.org_location_link = orgLocationLinkFromJSON(json.org_location_link);
  }

  return new LocationRecord(recordData);
};

export const orgLocationLinkFromJSON = (json: Partial<IOrgLocationLinkData>): OrgLocationLinkRecord => {
  const recordData = { ...(json as any) };
  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }
  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }
  return new OrgLocationLinkRecord(recordData);
};

export interface IOrgLocationLinkData {
  id: string;
  org_uuid: string;
  location_id: string;
  sort_order: number;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface ILocationData {
  id: string | number;
  name: string;
  org_id: Nullable<number>;
  org_location_link: Nullable<IOrgLocationLinkData>;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;

  loading?: boolean;
}

export interface IOrgLocationLinkRecord {
  id: string;
  org_uuid: string;
  location_id: string;
  sort_order: number;

  created_at: Date;
  updated_at: Date;
}

export interface ILocationRecord {
  id: string;
  name: string;
  org_id: Nullable<number>;
  org_location_link: Nullable<OrgLocationLinkRecord>;

  created_at: Date;
  updated_at: Date;

  loading: boolean;
}

export const defaultLocationProps = {
  id: "",
  name: "",
  org_id: null,
  org_location_link: null,
  created_at: new Date(),
  updated_at: new Date(),
  loading: false,
};

export const defaultOrgLocationLinkProps = {
  id: "",
  org_uuid: "",
  location_id: "",
  sort_order: 0,
  created_at: new Date(),
  updated_at: new Date(),
};

export class LocationRecord extends Record<ILocationRecord>(defaultLocationProps) implements ILocationRecord {}
export class OrgLocationLinkRecord
  extends Record<IOrgLocationLinkRecord>(defaultOrgLocationLinkProps)
  implements IOrgLocationLinkRecord {}
